import classNames from 'classnames';
import PropTypes from 'prop-types';
import { TooltipItem } from 'site-modules/shared/components/tooltip-item/tooltip-item';
import React from 'react';

import './info-tooltip.scss';

export function InfoTooltip({ className = undefined, iconClassName = undefined, ...rest }) {
  return (
    <TooltipItem
      className={classNames('info-tooltip pos-r align-middle d-inline-block', className)}
      iconClassName={classNames(
        'info-tooltip-icon pos-a d-inline-flex align-items-center justify-content-center bottom-0',
        iconClassName
      )}
      {...rest}
    />
  );
}

InfoTooltip.propTypes = {
  className: PropTypes.string,
  iconClassName: PropTypes.string,
};
